import { useEffect, useRef, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-router-dom'
import dropdownArrow from 'assets/icon/ico_footer-arrow_18.png'
import enLogoB from 'assets/icon/logo/img_footer-logo_260.png'
import STYLE_GUIDE from 'shared/constants/color'
import styled, { keyframes } from 'styled-components'

const Footer = () => {
  const outsideRef = useRef()

  const isMobile = useMediaQuery({
    query: '(max-width:883px)',
  })

  const menu = [
    { key: 'option_1', label: '스마트피싱보호', link: 'https://www.antiscam.co.kr/' },
    { key: 'option_2', label: '오토콜', link: 'https://www.autocall.ai/' },
    { key: 'option_3', label: '휴대폰분실보호', link: 'https://www.mfinder.co.kr/home' },
    {
      key: 'option_4',
      label: '휴대폰분실보호',
      subLabel: 'Global',
      link: 'https://www.mfinder.ai/ ',
    },
    { key: 'option_5', label: '휴대폰가족보호', link: 'https://www.familycare.ai/' },
    { key: 'option_6', label: '휴대폰쿠폰지갑', link: 'https://www.couponwallet.co.kr/' },
    { key: 'option_7', label: '이벤트유', link: 'https://www.eventu.co.kr/' },
  ]

  const dropdownItem = useRef()
  const dropdownList = useRef()
  const [arrow, setArrow] = useState(false)

  const handleClick = () => {
    if (dropdownItem.current.classList.contains('on')) {
      dropdownItem.current.classList.remove('on')
      dropdownList.current.classList.remove('on')
      // setArrow(false)
    } else {
      dropdownItem.current.classList.add('on')
      dropdownList.current.classList.add('on')
      // setArrow(true)
    }
  }

  useEffect(() => {
    function handleClickOutside(event) {
      // 현재 document에서 mousedown 이벤트가 동작하면 호출되는 함수입니다.
      if (dropdownList.current && !dropdownList.current.contains(event.target)) {
        if (dropdownItem.current.classList.contains('on')) {
          dropdownItem.current.classList.remove('on')
          dropdownList.current.classList.remove('on')
        }
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [dropdownList])

  return (
    <FooterWrap ref={outsideRef}>
      <FooterContent className="container">
        <div className="logo_area">
          <img src={enLogoB} alt={'로고'} />
        </div>
        <div className="info_area">
          <div className="address_area">
            <address>
              <p>
                {isMobile ? '' : <span>&nbsp;&middot;</span>}주소 : 서울특별시 영등포구 여의대로 70
                원센티널 10층{isMobile ? <br /> : <span>&nbsp;</span>}
                <span>(대표 : 강원석)</span>
              </p>
              <div className={'sub_info'}>
                <span className="copr_num">
                  {isMobile ? '' : <span>&nbsp;&middot;</span>}사업자등록번호 : 382-86-01230
                </span>
                <span className="copr_num">
                  {isMobile ? '' : <span>&nbsp;&middot;</span>}통신판매업 신고번호 :
                  제2020-서울영등포-1315호
                </span>
              </div>
              <div className={'svc_number'}>
                <span>{isMobile ? '' : <span>&nbsp;&middot;</span>}고객센터 :</span>
                <ul>
                  <li>
                    <a href="tel:1811-7531" title="스마트피싱보호 전화연결">
                      1811-7531
                    </a>
                    <span>(스마트피싱보호)</span>
                  </li>
                  <li>
                    <a href="tel:1811-4031" title="휴대폰분실보호 전화연결">
                      1811-4031
                    </a>
                    <span>(휴대폰분실보호)</span>
                  </li>
                  <li>
                    <a href="tel:1566-7531" title="오토콜 전화연결">
                      1566-7531
                    </a>
                    <span>(오토콜)</span>
                  </li>
                  <li>
                    <a href="tel:1855-3631" title="휴대폰가족보호 전화연결">
                      1855-3631
                    </a>
                    <span>(휴대폰가족보호)</span>
                  </li>
                  <li>
                    <a href="tel:1877-7331" title="이벤트U 전화연결">
                      1877-7331
                    </a>
                    <span>(이벤트유)</span>
                  </li>
                  <li>
                    <a href="tel:1855-4531" title="휴대폰쿠폰지갑 전화연결">
                      1855-4531
                    </a>
                    <span>(휴대폰쿠폰지갑)</span>
                  </li>
                </ul>
              </div>
              {/*<a className="tel_number" href="tel:02-6013-0625">
                {isMobile ? '' : <span>&middot;</span>} Tel : 02-6013-0625
              </a>
              <span className="fax_number">
                {isMobile ? '' : <span>&middot;</span>} Fax : 02-6105-6396
              </span>*/}
            </address>
            <div className="copy_wrap">
              <span className="copyright">&copy; 2025 DataUniverse All rights reserved.</span>
            </div>
          </div>
          <div className="corp_area">
            <ul className="corp_list">
              <li className="corp_item">
                <Link to={'information'} state={{ state: 1 }}>
                  회사 소개
                </Link>
              </li>
              <li className="corp_item">
                <Link to={'information'} state={{ state: 6 }}>
                  제휴/문의
                </Link>
              </li>
              <li className="corp_item dropdown_list" ref={dropdownList}>
                <DropdownMenu
                  className="dropdown_menu"
                  ref={dropdownItem}
                  onClick={handleClick}
                  arrow={arrow}
                >
                  <button className="btn_service">
                    <span>서비스</span>
                    {<img src={dropdownArrow} alt="arrow" />}
                  </button>
                  <ul className="service_depth">
                    {menu.map((item) => (
                      <li key={item.key}>
                        <a href={item.link} target={'_blank'} rel="noreferrer">
                          {item.label}
                          <span> {item.subLabel}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </DropdownMenu>
              </li>
            </ul>
          </div>
        </div>
      </FooterContent>
    </FooterWrap>
  )
}
export default Footer

const setOpacticy = keyframes`
    0% {
        opacity: 0;
        transform: translateY(-20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`

const FooterWrap = styled.footer`
  width: 100%;
  height: 234px;
  background-color: #fff;
  border-top: 1px solid ${STYLE_GUIDE.COLOR.gray3};

  @media screen and (max-width: 1919px) {
    height: 374px;
  }
  @media screen and (max-width: 1199px) {
    height: 351px;
  }
  @media screen and (max-width: 883px) {
    height: 517px;
  }
`

const FooterContent = styled.div`
  display: flex;
  padding-top: 50px;
  justify-content: space-between;

  .logo_area {
    img {
      width: 210px;
    }
  }

  .info_area {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .address_area {
    margin: 0 130px;
    max-width: 627px;
    font-weight: 400;
    font-size: 16px;
    text-align: left;
    line-height: 30px;
    color: ${STYLE_GUIDE.COLOR.black3};

    .sub_info {
      display: inline;
    }

    .copy_wrap {
      margin-top: 10px;
    }

    .copyright {
      color: ${STYLE_GUIDE.COLOR.gray1};
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
    }

    .svc_number {
      display: flex;
      gap: 3px;

      span {
        flex-shrink: 0;
      }

      ul {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        li {
          margin-right: 2px;
          text-align: left;

          a {
            color: ${STYLE_GUIDE.COLOR.black3} !important;
          }
        }
      }

      @media screen and (max-width: 883px) {
        ul {
          grid-template-columns: repeat(1, 1fr);
        }
      }
    }
  }

  .address_area:last-child {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }

  .corp_area {
    .corp_list {
      position: relative;
    }

    .corp_item {
      display: inline-block;
      font-weight: 700;
      font-size: 18px;
      color: ${STYLE_GUIDE.COLOR.black3};

      a {
        color: ${STYLE_GUIDE.COLOR.black3};
        opacity: 0.8;
      }
    }

    .corp_item:not(:last-child) {
      margin-right: 50px;
    }

    .corp_item.dropdown_list {
      width: 180px;
      height: 50px;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;

      &.on:before {
        height: 300px;
        color: ${STYLE_GUIDE.COLOR.black3};
        box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.06);
        z-index: 10;
      }

      > div {
        padding: 10px 20px;
        position: relative;
      }
    }

    .corp_item.dropdown_list:before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      background: ${STYLE_GUIDE.COLOR.white};
      transition: all 0.3s ease;
      width: 180px;
      height: 50px;
      border: 1px solid #dbdbdb;
      border-radius: 30px;
    }

    .btn_service {
      cursor: pointer;
    }

    .dropdown_menu {
      cursor: pointer;
    }
  }

  @media screen and (max-width: 1919px) {
    .info_area {
      width: auto;
      flex-direction: column;
    }

    .address_area {
      margin: 0;

      .sub_info {
        display: block;
      }

      .fax_number {
        display: block;
      }
    }

    .corp_area {
      padding: 40px 0 0 0;
    }
  }

  @media screen and (max-width: 1199px) {
    justify-content: space-between;
    padding-top: 30px;

    .logo_area {
      img {
        width: 158px;
      }
    }

    .info_area {
      width: auto;
      flex-direction: column;
    }

    .address_area {
      margin: 0;
      max-width: 548px;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;

      .sub_info {
        display: block;
      }

      .fax_number {
        display: block;
      }

      .tel_number {
        display: block;
      }

      .copr_num {
        display: block;
      }

      .copyright {
        color: ${STYLE_GUIDE.COLOR.gray1};
      }
    }

    .corp_area {
      padding: 20px 0 0 0;

      .corp_item {
        line-height: 26px;
        font-size: 16px;
      }

      .corp_item.dropdown_list {
        padding: 20px 0 0 0;
        width: 321px;
        display: block;
      }

      .corp_item.dropdown_list:before {
        width: 321px;
      }

      .btn_service {
        font-size: 16px;
        line-height: 26px;
      }
    }
  }

  @media screen and (max-width: 883px) {
    display: block;
    padding: 41px 0 0 0;

    .logo_area {
      img {
        width: 160px;
      }
    }

    .info_area {
      display: block;
      padding-top: 20px;
    }

    .address_area {
      margin: 0;
      font-size: 14px;
      line-height: 24px;

      .sub_info {
        display: flex;
        flex-direction: column;
      }

      address > p {
        letter-spacing: -0.1px;
      }

      address > span {
        display: block;
      }

      .address_area > div {
        padding-top: 10px;
      }

      .copy_wrap {
        padding-top: 10px;
      }

      .copyright {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: ${STYLE_GUIDE.COLOR.gray1};
      }
    }

    .corp_area {
      padding: 20px 0 0 0;

      .corp_list .corp_item:not(:last-child) {
        margin-right: 20px;
      }

      .corp_list .corp_item:last-child {
        padding-top: 20px;
      }

      .dropdown_list {
        display: block;
      }

      .corp_item {
        font-size: 18px;
        line-height: 26px;

        a {
          color: ${STYLE_GUIDE.COLOR.black3};
        }
      }

      .corp_item.dropdown_list {
        cursor: pointer;
        display: block;
        width: 321px;

        .dropdown_menu {
          padding: 12px 20px;
        }
      }

      .corp_item.dropdown_list:before {
        width: 321px;
      }
    }

    .service_depth {
      span {
        font-size: 16px;
      }
    }
  }
`

const DropdownMenu = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  z-index: 10;

  &.on > ul {
    visibility: visible;
    animation: ${setOpacticy} 0.5s forwards;
    opacity: 1;
  }

  > ul {
    position: absolute;
    opacity: 0;
    visibility: hidden;
  }

  > ul > li {
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    color: ${STYLE_GUIDE.COLOR.black3};
  }

  .btn_service {
    border-radius: 30px;
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    color: ${STYLE_GUIDE.COLOR.black3};
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      opacity: 0.8;
    }

    img {
      width: 18px;
      cursor: pointer;
    }
  }

  &.on {
    .btn_service {
      img {
        transform: rotate(180deg);
      }
    }
  }

  .service_depth {
    bottom: 65px;

    li > a {
      color: ${STYLE_GUIDE.COLOR.black4} !important;
      opacity: 1 !important;
    }

    span {
      font-size: 11px;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    .service_depth {
      bottom: 75px;

      span {
        font-size: 16px;
      }
    }
  }

  @media screen and (max-width: 883px) {
    .btn_service {
      font-size: 16px;
      line-height: 26px;

      img {
        width: 26px;
        cursor: pointer;
      }
    }

    .service_depth {
      bottom: 75px;

      span {
        font-size: 16px;
      }
    }
  }
`
